const { errors, languages } = require('@transfeeradev/api-enums');
const merge = require('deepmerge');
const ErrorMessageCompiler = require('./ErrorMessageCompiler');

const NOT_FOUND_MESSAGE = 'Message not found';
const NOT_FOUND_TRANSLATION = 'Translation not found';

class ErrorMessageTranslator {
  constructor(language) {
    this._language = language || languages.EN;
  }

  translate(messageCode, data) {
    const defaultMessage = this._getMessageWithKeyName(languages.PT_BR, messageCode);
    if (defaultMessage) {
      const translatedMessage = errors[this._language][defaultMessage.contextName][defaultMessage.keyName];
      if (!translatedMessage) {
        throw new Error(`${NOT_FOUND_TRANSLATION} | code: ${messageCode}`);
      }
      const fullMessage = merge.all([{}, defaultMessage.errorMessage, translatedMessage]);
      return new ErrorMessageCompiler(fullMessage, data).compile();
    } else {
      throw new Error(`${NOT_FOUND_MESSAGE} | code: ${messageCode}`);
    }
  }

  _getMessageWithKeyName(language, code) {
    const messagesContexts = errors[language];

    for (let contextName in messagesContexts) {
      let context = messagesContexts[contextName];

      for (let errorMessageKeyName in context) {
        let errorMessage = context[errorMessageKeyName];

        if (errorMessage.code === code) {
          return {
            errorMessage,
            contextName,
            keyName: errorMessageKeyName
          };
        }
      }
    }
    return null;
  }
}

module.exports = ErrorMessageTranslator;
